import { render } from "./ShopLateralList.vue?vue&type=template&id=2d3945eb&bindings={\"language\":\"setup\",\"changeShopFunction\":\"props\",\"selected\":\"props\",\"content\":\"props\",\"title\":\"props\",\"list_shops\":\"props\",\"isLoading\":\"data\",\"changeShop\":\"options\",\"startRender\":\"options\",\"getContentClass\":\"options\",\"checkSelected\":\"options\"}"
import script from "./ShopLateralList.vue?vue&type=script&lang=js"
export * from "./ShopLateralList.vue?vue&type=script&lang=js"

import "./ShopLateralList.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script